/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Data classes.
*/
export enum DataClass {
  Fi = 'FI',
  Phi = 'PHI',
  Pii = 'PII',
  DataClassUnspecified = 'DATA_CLASS_UNSPECIFIED'
}
